/* Angular Component */
import { Component } from "@angular/core";
@Component({
  selector: "back-to-scheduler",
  templateUrl: "./back-to-scheduler.component.html",
  styleUrls: ["./back-to-scheduler.component.scss"],
})
export class BackToSchedulerComponent {}
